/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicLinkRequest
 */
export interface MagicLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof MagicLinkRequest
     */
    email: string;
}

/**
 * Check if a given object implements the MagicLinkRequest interface.
 */
export function instanceOfMagicLinkRequest(value: object): value is MagicLinkRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function MagicLinkRequestFromJSON(json: any): MagicLinkRequest {
    return MagicLinkRequestFromJSONTyped(json, false);
}

export function MagicLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

  export function MagicLinkRequestToJSON(json: any): MagicLinkRequest {
      return MagicLinkRequestToJSONTyped(json, false);
  }

  export function MagicLinkRequestToJSONTyped(value?: MagicLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

